export default __webpack_public_path__ + "static/media/favicon-16x16.46d8eeb8.png";